module.exports = __webpack_public_path__ + "img/logo.7cf8e7b7.png";